import * as Type from './types'

import { executeCallback, setInMemory } from '@services/store/utils'

const initialState = {
    data: {},
    formated: {},
    loaded: null
}

export default function LandingZoneServicesReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'landingZoneServices'
        )
    }
    else if (action.type === Type.SET_FORMAT) {
        return executeCallback(
            setInMemory(state, action, 'formated'),
            action,
            'landingZoneServices'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'landingZoneServices'
        )
    }

    return state
}
